module.exports = __webpack_public_path__ + "static/media/DualCarousel.f1234591.mp4";